"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetTransactions = void 0;
class GetTransactions {
    constructor(userRepository) {
        this.userRepository = userRepository;
    }
    execute(request, callback) {
        return this.userRepository.getTransactions(request, callback);
    }
}
exports.GetTransactions = GetTransactions;
